import { Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';
import styled from 'styled-components';

export const StyledTitle = styled(Typography)`
  text-align: center;
  margin-bottom: 60px;
  font-size: 48px;
  font-family: ${saasModernTheme.fontFamily};
  font-weight: 900;
  color: var(--Text-Primary, #111927);

  strong {
    background: ${saasModernTheme.customColor.backgroundTextGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media screen and(max-width: 950px) {
    font-size: 38px;
  }
  @media screen and (max-width: 600px) {
    font-size: 30px;
    width: 90%;
    margin: 60px auto 50px;
  }
`;

export const FaqWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  font-family: ${saasModernTheme.fontFamily};

  .accordion_item {
    position: relative;
    border-radius: 8px;
    margin-bottom: 16px;
    background-color: white;
    box-shadow: ${saasModernTheme.gradiantShadow};
    overflow: hidden;
    padding: 8px;
  }

  .accordion_item.active::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 8px;
    padding: 1px;
    background: linear-gradient(
      90deg,
      #006fff 35.43%,
      #ff6e72 49.87%,
      #ffb656 64.31%
    );
    mask:
      linear-gradient(white 0 0) content-box,
      linear-gradient(white 0 0);
    mask-composite: exclude;
    -webkit-mask:
      linear-gradient(white 0 0) content-box,
      linear-gradient(white 0 0);
    -webkit-mask-composite: xor;
  }
`;

export const FaqQuestion = styled(Typography)`
  color: #1e293b;
  margin: 0;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  padding-left: 20px;
  font-family: ${saasModernTheme.fontFamily};

  @media (max-width: 575px) {
    font-size: 16px;
  }
`;

export const FaqAnswer = styled.div`
  color: #64748b;
  font-size: 16px;
  padding-left: 20px;
  line-height: 1.6;
`;

export const ChildFaq = styled.div`
  flex: 1;
`;
